/**
 * Request microphone permissions for web recording
 * @returns {Promise<boolean>} True if permission granted
 */
export const requestWebRecordingPermission = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    stream.getTracks().forEach(track => track.stop()); // Clean up test stream
    return true;
  } catch (error) {
    console.error('Web recording permission denied:', error);
    return false;
  }
};
